import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/study-group")({
  component: () => <Outlet />,
});
